//#region Libraries
import styled from "styled-components";
//#endregion
//#region Styles
import { Row } from "components/styles";
//#endregion

export const Container = styled(Row)`
    align-self: center;
`;